import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DefaultComponent } from './default/default.component';
import { MainlayoutComponent } from './layouts/mainlayout/mainlayout.component';
import { ReportviewComponent } from './reportview/reportview.component';
import { DisclaimerpageComponent } from './disclaimer/disclaimerpage/disclaimerpage.component';
import { ProgrammeComponent } from './programme/programme.component';
import { ConfirmationComponent } from './confirmation/confirmation.component';
import { ModulesComponent } from './modules/modules.component';
import { PersonalinfoComponent } from './personalinfo/personalinfo.component';
import { DisclaimerprintComponent } from './disclaimer/disclaimerprint/disclaimerprint.component';
import { AuthGuardService } from './guards/auth-guard.service';
import { ErrorpageComponent } from './errorpage/errorpage.component';

const routes: Routes = [
  
  {
    path: '', redirectTo: 'default', pathMatch: 'full'
  },
  {
    path: 'default', component: MainlayoutComponent,
    children: [
      { path: '', component: DefaultComponent, outlet: 'main'},
      { path: 'disclaimer', component: DisclaimerpageComponent, outlet: 'main', canActivate: [AuthGuardService]},
      { path: 'disclaimerprint', component: DisclaimerprintComponent, outlet: 'main', canActivate: [AuthGuardService]},
      { path: 'programme', component: ProgrammeComponent, outlet: 'main', canActivate: [AuthGuardService]},
      { path: 'modules', component: ModulesComponent, outlet: 'main', canActivate: [AuthGuardService]},
      { path: 'summary', component: ConfirmationComponent, outlet: 'main', canActivate: [AuthGuardService]},
      { path: 'personalinfo', component: PersonalinfoComponent, outlet: 'main', canActivate: [AuthGuardService]},
      { path: 'report', component: ReportviewComponent, outlet: 'main', canActivate: [AuthGuardService]},
      { path: 'errorpage', component: ErrorpageComponent, outlet: 'main'}
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
